import { render, staticRenderFns } from "./ManageImages.vue?vue&type=template&id=6bf64af4"
import script from "./ManageImages.vue?vue&type=script&lang=js"
export * from "./ManageImages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports